// Canonical HAIVEN header mark — matches SignalScreen's original styling
// exactly (the app's reference implementation). Callers place it as the
// first or last child of their own `justify-content: space-between`
// header row to get top-left vs top-right positioning; this component
// only owns the mark's own size/spacing, never its position.
export function Wordmark({ style } = {}) {
  return (
    <img
      src="/wordmark-gold.png"
      alt="Haiven"
      style={{ height: 22, width: "auto", marginBottom: 3, ...style }}
    />
  );
}
